import { generateClient } from "aws-amplify/api";
import { getScratchPadData } from "@/graphql/queries";
const client = generateClient();
export const GetScratchPadText = {
  methods: {
    async GetScratchPadTextMethod() {
      try {
        let result = await client.graphql({
          query: getScratchPadData,
          variables: {
            input: {
              user_id: this.$store.getters.get_current_user_details.user_id,
            },
          },
        });
        var ResultObj = JSON.parse(result.data.getScratchPadData);
        if (ResultObj.status == 200 || ResultObj.status === "SUCCESS") {
          this.$store.commit(
            "SET_SCRATCHPAD_TEXT",
            ResultObj.data.scratch_pad_text,
          );
        }
      } catch (error) {
        this.noDataText = error.errors[0].message;
        console.log("Error", error);
      }
    },
  },
};
